const ToggleLeft = ({ color, type }) => {
  const regular = (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.9167 12.9167L27.0833 12.9167C30.9953 12.9167 34.1667 16.088 34.1667 20C34.1667 23.912 30.9953 27.0833 27.0833 27.0833L12.9167 27.0833M12.9167 12.9167C9.00465 12.9167 5.83333 16.088 5.83333 20C5.83333 23.912 9.00464 27.0833 12.9167 27.0833M12.9167 12.9167C16.8287 12.9167 20 16.088 20 20C20 23.912 16.8287 27.0833 12.9167 27.0833"
        stroke={color}
        strokeWidth="3.33333"
      />
      <circle cx="12" cy="20" r="7" fill={color} />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default ToggleLeft;
